import { Component, EventEmitter, Inject, Output } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ScheduleService } from "../../../shared/services/schedule.service";
import { SignalBoService } from "../../../shared/services/signalbo.service";
import { SignalMessage } from "../../models/SignalMessage";
import { TradePlan } from "../../models/TradePlan";

@Component({
  selector: "app-signals-delete-modal",
  templateUrl: "../templates/signalsPusblishScheduleModal.component.html",
})
export class SignalsPublishScheduleModalComponent {
  @Output() itemPublished: EventEmitter<SignalMessage | TradePlan> =
    new EventEmitter<SignalMessage | TradePlan>();

  private item: string;
  private tradePlan: TradePlan;
  private message: SignalMessage;
  private inProgress: Boolean;
  constructor(
    private dialogRef: MatDialogRef<SignalsPublishScheduleModalComponent>,
    private signalBoService: SignalBoService,
    private scheduleService: ScheduleService,
    @Inject(MAT_DIALOG_DATA)
    private _data: {
      message: SignalMessage;
    }
  ) {
    this.message = this._data.message;
  }

  async accept() {
    let result;
    this.inProgress = true
    if (this.message) {
      result = await this.handleDeleteMessage();

      if (result) {
        this.itemPublished.emit(this.message);
      }
    }
    this.inProgress = false;
    this.close();
  }

  close() {
    this.dialogRef.close();
  }

  private async handleDeleteMessage() {
    let result;
    // result = await this.scheduleService
    //   .DeleteScheduled(this.message.id)
    //   .toPromise().then(x => {
    //     this.signalBoService
    //       .CreateMessage(this.message.content)
    //       .toPromise();
    //   });

    result = await this.signalBoService
      .CreateMessage(this.message.content)
      .toPromise()

    if (result)
      await this.scheduleService.DeleteScheduled(this.message.id).toPromise();

    return result;
  }

  public get Item() {
    return this.item;
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsPublishScheduleModal.component.ts